import { ForwardedRef, forwardRef, useEffect, useState } from "react";
import TextSplit, { TextAlign } from "../../TextSplit/TextSplit";
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ReactPlayer from 'react-player'

import './WeMachineSlide2.css';
import TextVideoSegment from "../../TextVideoSegment/TextVideoSegment";
import SellingPointCard from "../../SellingPointCard/SellingPointCard";

gsap.registerPlugin(ScrollTrigger);

const WeMachineSlide2 = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
    useEffect(() => {
    }, []);

    return (
        <>
            <Box className="we-machine-wrapper-container">
                <Box className="why-billet-and-video">
                    <Box className="text-segment">
                        <Box className="title-container we-machine-text-container" id="we-machine--1">
                            <Box className="we-machine-text-container-item" id="separation-div">
                                <TextSplit
                                    className="slide-h1" 
                                    id="we-machine--1" 
                                    align={TextAlign.LEFT}
                                    sx={{ fontSize: { xs: '46px', sm: '57px', md: '69px', lg: '80px' } }}
                                >
                                    Why
                                </TextSplit>
                                <TextSplit 
                                    className="slide-h1" 
                                    id="we-machine--1-1" 
                                    align={TextAlign.LEFT}
                                    sx={{ fontSize: { xs: '46px', sm: '57px', md: '69px', lg: '80px' } }}
                                >
                                    Billet
                                </TextSplit>
                            </Box>
                            <TextSplit 
                                className="slide-h1" 
                                id="we-machine--1-1" 
                                align={TextAlign.LEFT}
                                sx={{ fontSize: { xs: '46px', sm: '57px', md: '69px', lg: '80px' } }}
                            >
                                Precision?
                            </TextSplit>
                        </Box>
                        <Box className="title-container we-machine-text-container" id="we-machine-0">
                            <TextSplit 
                                className="slide-h1" 
                                id="we-machine-0" 
                                align={TextAlign.LEFT}
                                sx={{ fontSize: { xs: '20px', sm: '25px', md: '30px', lg: '35px' } }}
                            >
                                We machine high precision, complex mission critical components. We take pride in being more than just a high-end machine shop. We are your strategic ally in the pursuit of manufacturing perfection.
                            </TextSplit>
                        </Box>
                    </Box>
                    <Box className="video-segment">
                        <ReactPlayer url='https://www.youtube.com/watch?v=_ktDjfSaEP8' />
                    </Box>
                </Box>
                <Box className="selling-point-grid">
                    <Box className="grid-container" id="selling-point-grid-container">
                        <Grid container className="selling-point-content-container" id="we-machine" direction="row">
                            <Grid item xs={6}>
                                <SellingPointCard id={""} iconType="Engineering" pointTitle={"Custom Solutions for Diverse Industries"} pointDescription={"Serving industries such as aerospace, defense & military, optics & surveillance, marine, telecommunications, and medical. We provide tailored CNC solutions to meet unique challenges. No project is too big or small—our versatility ensures we can handle all your manufacturing needs."} />
                            </Grid>
                            <Grid item xs={6}>
                                <SellingPointCard id={""} iconType="PrecisionManufacturing" pointTitle={"Unmatched Precision and Quality"} pointDescription={"At our CNC precision manufacturing shop, we utilize our CNC machines to deliver exceptional accuracy and quality. Every component we produce meets the strictest tolerances, ensuring reliability and performance for even the most demanding applications."} />
                            </Grid>
                            <Grid item xs={6}>
                                <SellingPointCard id={""} iconType="Lightbulb" pointTitle={"Innovative Solutions Driven by Expertise"} pointDescription={"Backed by various machinery and a highly skilled team, we specialize in complex and high-precision manufacturing. From prototyping to large-scale production, we combine innovation and experience to meet your exact specifications."} />
                            </Grid>
                            <Grid item xs={6}>
                                <SellingPointCard id={""} iconType="SupportAgent" pointTitle={"Commitment to Exceptional Customer Service"} pointDescription={"We prioritize building strong relationships with our clients by offering personalized support at every stage of the manufacturing process. From design feedback to final production, our team works closely with you to ensure your requirements are met with precision, transparency, and care."} />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <Box className="discover-services">

                </Box>
            </Box>
            <Box className="content-slide" id="we-machine" ref={ref}>
                <Grid container direction={'column'} className="content-container" id="we-machine">
                    <Grid item>
                        <TextVideoSegment
                            id="design-feedback"
                            title="Design Feedback"
                            body={
                                [
                                    "We recognize the importance of precision in critical components, and that's why we offer comprehensive Design Feedback services. Whether you are in the early stages of product development or looking to optimize existing designs for manufacturing efficiency, we are here to support you. At Billet Precision Ltd, we redefine the standards of excellence in the world of machining.",
                                ]} video={'/videos/home/slides/we-machine/design-feedback-1080p.mp4'} />
                    </Grid>
                    <Grid item>
                        <TextVideoSegment
                            id="cnc-programming"
                            title="CNC Programming"
                            body={
                                [
                                    "As a unique high-end machine shop specializing in the manufacturing of critical components, we are delighted to offer an additional dimension to our services that includes CNC Programming. Our team of skilled programmers harnesses the power of cutting-edge technology to create meticulous CNC programs tailored to your exact specifications. Whether you are entrusting us with a new project or seeking to optimize existing programs, Billet Precision Ltd ensures that your components are crafted with unparalleled accuracy.",
                                ]} video={'/videos/home/slides/we-machine/cnc-programming-1080p.mp4'} />
                    </Grid>
                    <Grid item>
                        <TextVideoSegment
                            id="cnc-machining"
                            title="CNC Machining"
                            body={
                                [
                                    "Billet Precision Ltd is equipped with cutting-edge technology and a team of skilled machinists who possess the expertise to transform your designs into reality with unparalleled precision. We understand the critical nature of the components we manufacture, and our focus is on delivering perfection in every detail. What sets us apart is our proficiency in machining intricate and complex parts with the highest degree of accuracy. Billet Precision Ltd is your trusted partner when it comes to crafting components that are mission-critical, where precision is not just a requirement but an absolute necessity. Our machining capabilities are tailored to meet the most stringent standards, ensuring that your components perform flawlessly in the most demanding applications. Our CNC machining services are seamlessly integrated with our CNC programming and design feedback expertise, creating a comprehensive solution that guarantees precision from concept to completion.",
                                ]} video={'/videos/home/slides/we-machine/cnc-machining-1080p.mp4'} />
                    </Grid>
                    <Grid item>
                        <TextVideoSegment
                            id="cmm-inspection"
                            title="CMM Inspection"
                            body={
                                [
                                    "Billet Precision Ltd is proud to offer CMM Inspection as a dedicated service. As a high precision machine shop, specializing in tight-tolerance manufacturing, our advanced CMM capabilities ensure every component is meticulously measured to meet the highest standards of accuracy and quality.",
                                ]} video={'/videos/home/slides/we-machine/cmm-inspection-1080p.mp4'} />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
});


export default WeMachineSlide2;